import $ from "jquery";

const CAPACITOR_SERVER_ORIGIN = 'https://ipro.autopro.ai.kr';
const DEFAULT_REQUEST_TIMEOUT_MS = 10000;

function isNativePlatform(): boolean {
    const capacitor = (window as any).Capacitor;
    return !!capacitor && !!capacitor.isNativePlatform && capacitor.isNativePlatform();
}

function resolveCapacitorServerOrigin(): string {
    try {
        const current = new URL(window.location.href);
        const hostname = current.hostname.toLowerCase();
        if (current.protocol === 'https:' && hostname.endsWith('.autopro.ai.kr')) {
            return current.origin;
        }
    } catch {}
    return CAPACITOR_SERVER_ORIGIN;
}

function resolveUrl(url: string): string {
    const normalized = String(url || '').trim();
    if (!normalized) return normalized;
    if (/^https?:\/\//.test(normalized)) return normalized;
    if (!isNativePlatform()) return normalized;

    const serverOrigin = resolveCapacitorServerOrigin();
    if (normalized.startsWith('/')) {
        return `${serverOrigin}${normalized}`;
    }

    return `${serverOrigin}/${normalized}`;
}

function getNativeHttp(url: string): any | null {
    const capacitor = (window as any).Capacitor;
    if (!capacitor || !capacitor.isNativePlatform || !capacitor.isNativePlatform() || !/^https?:///.test(url)) {
        return null;
    }
    try {
        if (capacitor.Plugins?.CapacitorHttp?.post) return capacitor.Plugins.CapacitorHttp;
        if (capacitor.registerPlugin) return capacitor.registerPlugin('CapacitorHttp');
    } catch {}
    return null;
}

function encodeFormData(data: any): string {
    const body = new URLSearchParams();
    Object.keys(data || {}).forEach((key) => {
        const value = data[key];
        if (value !== undefined && value !== null) body.append(key, String(value));
    });
    return body.toString();
}

export default class Request {
    constructor() { }

    public async post(url: string, data: any = {}) {
        const resolvedUrl = resolveUrl(url);
        const nativeHttp = getNativeHttp(resolvedUrl);

        if (nativeHttp) {
            try {
                const response = await nativeHttp.post({
                    url: resolvedUrl,
                    data: encodeFormData(data),
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    connectTimeout: DEFAULT_REQUEST_TIMEOUT_MS,
                    readTimeout: DEFAULT_REQUEST_TIMEOUT_MS,
                    responseType: 'json'
                });
                let payload = response ? response.data : null;
                if (typeof payload === 'string') {
                    try { payload = JSON.parse(payload); } catch {}
                }
                return payload;
            } catch (error) {
                console.warn('[Request] native-http failed:', error);
            }
        }

        let request = () => {
            return new Promise((resolve) => {
                $.ajax({
                    url: resolvedUrl,
                    type: "POST",
                    data: data,
                    crossDomain: /^https?:///.test(resolvedUrl),
                    xhrFields: {
                        withCredentials: true
                    },
                    timeout: DEFAULT_REQUEST_TIMEOUT_MS
                }).always(function (res) {
                    resolve(res);
                });
            });
        }

        return await request();
    }

}
